import React from 'react'
import styled from 'styled-components'


export default function Me() {
    return (
        <Container>  
            <Box>
                <h1>Who is Vince?</h1>
                Driven by a passion for video and trading card games, I’ve built a career that spans customer support, social media, sales, marketing, organized play, events, community management, and operations. My journey has been defined by creating engaging player experiences and growing brand communities<br/><br/>

                Throughout my career, I’ve collaborated with leading brands such as Upper Deck, Konami, Loot Crate, IGN, Netmarble, Kabam, Arc System Works, Level Up Productions, OS Studios, and many more!<br/><br/>

                <center><h1>Let's create together!</h1></center>
    
                <Links>
                    <a href="https://www.linkedin.com/in/vlnce" target="_blank" rel="noopener noreferrer">
                        LinkedIn
                    </a>
                    <a href="mailto:vinceryangarcia@gmail.com">Email Me</a>
                </Links>
            </Box>
        </Container>
    )
}

const Container = styled.div`
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;

@media only screen and (min-width: 600px) {
    margin-left:20%;
    margin-right:20%;
}
`

const Links = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;

    a {
        text-decoration: none;
        color: #0077b5; /* LinkedIn blue vibe */
        font-weight: bold;
    }

    a:hover {
        text-decoration: underline;
    }
`

const Box = styled.div`
    width: 400px;
`